import { CardIcon, HistoryIcon, LayersIcon, UserPlusIcon } from './sidebar/component/SidebarIcons';
import { AccountRole, RouteVersion } from '../models';
import { RouteConfig } from '../routes';
import SubscriptionManagement from '../pages/deprecated/subscription-management';
import { RouteType } from '../routes/routeType';
import { PermissionAction, ResourcePolicy } from '../models/permission';
import CheckoutPage from '../pages/checkout';
import { OrderConfirmationPage } from '../pages/order-confirmation';
import { Subscription } from '../pages/subscription';
import { Plan } from '../pages/plan';
import { Order } from '../pages/order';
import PaymentMethod from '../pages/payment-method';
import { AccountSelection } from '../pages/account-selection';
import PaymentStatus from '../pages/payment-status';
import SsoComponent from '../pages/sso';
import { LandingPage } from '../pages/landing-page/LandingPage';
import { ConfirmPaymentPage } from '../pages/confirm-payment';

// old G2 routes
export const subscriptionManagement: RouteConfig = {
  path: '/subscription-management',
  icon: <LayersIcon />,
  menuGroup: 'manage',
  element: <SubscriptionManagement key="subscription-management" />,
  requireAuth: true,
  pageTitle: 'layout.tab.subscription.title',
  accountRequired: true,
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  showInMenu: true,
  version: RouteVersion.V1,
  replacePath: '/subscription',
};

export const purchase: RouteConfig = {
  path: '/subscription-management/purchase',
  icon: <LayersIcon />,
  element: <SubscriptionManagement key="purchase" />,
  requireAuth: true,
  pageTitle: 'layout.tab.subscription.title',
  accountRequired: true,
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  version: RouteVersion.V1,
  replacePath: '/plan/purchase',
};

export const paymentMethod: RouteConfig = {
  path: '/payment-method',
  icon: <CardIcon />,
  menuGroup: 'billing',
  element: <SubscriptionManagement key="payment-method" />,
  requireAuth: true,
  accountRequired: true,
  pageTitle: 'layout.tab.payment.title',
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  showInMenu: true,
  version: RouteVersion.V1,
  replacePath: '/payment',
};

// new Purchase flow routes
export const subscription: RouteConfig = {
  path: '/subscription',
  icon: <LayersIcon />,
  menuGroup: 'manage',
  element: <Subscription key="subscriptions" />,
  requireAuth: true,
  accountRequired: true,
  pageTitle: 'layout.tab.subscription.title',
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  showInMenu: true,
  version: RouteVersion.V2,
  replacePath: '/subscription-management',
};

export const plan: RouteConfig = {
  path: '/plan',
  icon: <UserPlusIcon />,
  menuGroup: 'manage',
  element: <Plan key="expand-plan" />,
  requireAuth: true,
  accountRequired: true,
  pageTitle: 'layout.tab.plan.title',
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  showInMenu: true,
  version: RouteVersion.V2,
};

export const starter: RouteConfig = {
  path: '/starter',
  redirect: plan.path,
};

export const payment: RouteConfig = {
  path: '/payment',
  icon: <CardIcon />,
  menuGroup: 'billing',
  element: <PaymentMethod key="payment-billing" />,
  requireAuth: true,
  accountRequired: true,
  pageTitle: 'layout.tab.payment.title',
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  showInMenu: true,
  version: RouteVersion.V2,
  replacePath: '/payment-method',
};

export const order: RouteConfig = {
  path: '/order',
  icon: <HistoryIcon />,
  menuGroup: 'billing',
  element: <Order key="order-history" />,
  requireAuth: true,
  accountRequired: true,
  pageTitle: 'layout.tab.order.title',
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  showInMenu: true,
  version: RouteVersion.V2,
};

export const checkout: RouteConfig = {
  path: '/plan/purchase',
  element: <CheckoutPage key="checkout" />,
  requireAuth: true,
  pageTitle: 'layout.tab.checkout.title',
  accountRequired: true,
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  version: RouteVersion.V2,
  replacePath: '/subscription-management/purchase',
};

export const confirmPayment: RouteConfig = {
  path: '/plan/confirm-payment',
  element: <ConfirmPaymentPage key="confirm-payment" />,
  requireAuth: true,
  pageTitle: 'layout.tab.confirm.payment.title',
  accountRequired: true,
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE],
  version: RouteVersion.V2,
};

export const orderConfirmation: RouteConfig = {
  path: '/plan/order-confirmation',
  element: <OrderConfirmationPage key="order-confirmation" />,
  requireAuth: true,
  pageTitle: 'layout.tab.order.confirmation.title',
  accountRequired: true,
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  version: RouteVersion.V2,
};

export const accountSelection: RouteConfig = {
  path: '/select-account',
  element: <AccountSelection key="account-selection" />,
  requireAuth: true,
  pageTitle: 'layout.tab.account_selection.title',
  accountRequired: false,
  isRootOrAdminAccessible: true,
  showSidebar: false,
  showNavbar: false,
};

export const paymentStatus: RouteConfig = {
  path: '/plan/payment-status',
  element: <PaymentStatus key="payment-status" />,
  requireAuth: true,
  pageTitle: 'layout.tab.payment_status.title',
  accountRequired: true,
  accessibleRoles: [
    AccountRole.OWNER,
    AccountRole.BILLING_MANAGER,
  ],
  isRootOrAdminAccessible: true,
  type: RouteType.ACCOUNT,
  resource: ResourcePolicy.SUBSCRIPTION,
  actions: [PermissionAction.CREATE, PermissionAction.UPDATE, PermissionAction.DELETE],
  version: RouteVersion.V2,
};

export const sso: RouteConfig = {
  path: '/sso',
  element: <SsoComponent />,
  requireAuth: true,
};

export const landingPage: RouteConfig = {
  path: '/landing-page',
  element: <LandingPage key="landing-page" />,
  requireAuth: true,
  pageTitle: 'layout.tab.landing_page.title',
  accountRequired: false,
  isRootOrAdminAccessible: true,
  showSidebar: false,
  showNavbar: false,
};

const routes: RouteConfig[] = [
  accountSelection,
  subscription,
  plan,
  starter,
  checkout,
  confirmPayment,
  orderConfirmation,
  payment,
  order,
  subscriptionManagement,
  paymentMethod,
  purchase,
  sso,
  paymentStatus,
  landingPage,
  {
    ...subscriptionManagement,
    path: '/subscription-management/*',
    requireAuth: true,
    accountRequired: true,
    element: <SubscriptionManagement />,
    showInMenu: false,
  },
];

export default routes;
